export const SET_SEARCH_BODY = 'SET_SEARCH_BODY';
export const RESET_SEARCH_BODY = 'RESET_SEARCH_BODY';
